var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/type/request/user/profile-attributes.dto.ts
import { IsObject } from "class-validator";
function _ts_decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
__name(_ts_decorate, "_ts_decorate");
function _ts_metadata(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
}
__name(_ts_metadata, "_ts_metadata");
var AttributeTypesNames = /* @__PURE__ */ function(AttributeTypesNames2) {
  AttributeTypesNames2["FirstName"] = "first_name";
  AttributeTypesNames2["LastName"] = "last_name";
  AttributeTypesNames2["CitizenshipCountry"] = "citizenship_country";
  AttributeTypesNames2["ResidenceCountry"] = "residence_country";
  AttributeTypesNames2["Birthday"] = "birthday";
  AttributeTypesNames2["Gender"] = "gender";
  AttributeTypesNames2["Address"] = "address";
  AttributeTypesNames2["City"] = "city";
  AttributeTypesNames2["Region"] = "region";
  AttributeTypesNames2["ZipCode"] = "zip_code";
  AttributeTypesNames2["PhoneNumber"] = "phone_number";
  AttributeTypesNames2["IsPEP"] = "is_pep";
  AttributeTypesNames2["SourceOfFunds"] = "source_of_funds";
  AttributeTypesNames2["SourceOfFundsExtra"] = "source_of_funds_extra";
  AttributeTypesNames2["SourceOfWealth"] = "source_of_wealth";
  AttributeTypesNames2["SourceOfWealthExtra"] = "source_of_wealth_extra";
  AttributeTypesNames2["ApproximateWealthValue"] = "approximate_wealth_value";
  AttributeTypesNames2["ApproximateAnnualIncomeValue"] = "approximate_annual_income_value";
  AttributeTypesNames2["ReferencedAccount"] = "referenced_account";
  AttributeTypesNames2["EmploymentStatus"] = "employment_status";
  AttributeTypesNames2["Profession"] = "profession";
  AttributeTypesNames2["MaritalStatus"] = "marital_status";
  AttributeTypesNames2["TinNumber"] = "tin_number";
  AttributeTypesNames2["IsUsTaxResident"] = "is_us_tax_resident";
  AttributeTypesNames2["CountryOfBirth"] = "country_of_birth";
  AttributeTypesNames2["AdditionalDepositsAvailable"] = "additional_deposits_available";
  AttributeTypesNames2["AvailableCountries"] = "available_countries";
  AttributeTypesNames2["Comment"] = "comment";
  AttributeTypesNames2["EarlyPartialWithdrawals"] = "early_partial_withdrawals";
  AttributeTypesNames2["EarlyTermination"] = "early_termination";
  AttributeTypesNames2["AnnualFee"] = "annual_fee";
  AttributeTypesNames2["Cashback"] = "cashback";
  AttributeTypesNames2["SourceUrl"] = "source_url";
  AttributeTypesNames2["DocumentFile"] = "document_file";
  AttributeTypesNames2["PhoneNumbers"] = "phone_numbers";
  AttributeTypesNames2["SingleBankAccountForDepositsIBAN"] = "single_bank_account_for_deposits_iban";
  AttributeTypesNames2["SingleBankAccountForDepositsBIC"] = "single_bank_account_for_deposits_bic";
  AttributeTypesNames2["ActionAtMaturity"] = "action_at_maturity";
  AttributeTypesNames2["IdentityVerificationReport"] = "identity_verification_report";
  AttributeTypesNames2["IdDocuments"] = "id_documents";
  AttributeTypesNames2["Selfie"] = "selfie";
  AttributeTypesNames2["ProofOfAddress"] = "proof_of_address";
  return AttributeTypesNames2;
}({});
var _ProfileAttributesDto = class _ProfileAttributesDto {
  constructor() {
    __publicField(this, "attributes");
  }
};
__name(_ProfileAttributesDto, "ProfileAttributesDto");
var ProfileAttributesDto = _ProfileAttributesDto;
_ts_decorate([
  IsObject(),
  _ts_metadata("design:type", Object)
], ProfileAttributesDto.prototype, "attributes", void 0);
export {
  AttributeTypesNames,
  ProfileAttributesDto
};
//# sourceMappingURL=profile-attributes.dto.mjs.map